import type { SubmissionReviewProps } from './utils.js';
import { useSubmissionState } from './hooks/use-submission-state.js';
import {
  ReviewTopBar,
  UnassignedPagesBucket,
  StudentBucketRow,
  PreviewLightboxModal,
} from './components/submission-panels.js';

export function SubmissionReview(props: SubmissionReviewProps) {
  const store = useSubmissionState(props);

  return (
    <div className="flex flex-col h-full bg-slate-50 dark:bg-secondary rounded-xl overflow-hidden">
      <ReviewTopBar store={store} />

      <div className="flex-1 overflow-y-auto py-4 px-2 space-y-6">
        <UnassignedPagesBucket store={store} />

        <div className="space-y-4">
          {store.state.allBuckets.map((bucket, index) => (
            <StudentBucketRow key={bucket.id} store={store} bucket={bucket} index={index} />
          ))}
        </div>
      </div>

      <PreviewLightboxModal store={store} />
    </div>
  );
}
